/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_FailedInputs */

const cs_import_stat_failed = /** @type {(inputs: Import_Stat_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selhalo: ${i?.count}`)
};

const en_import_stat_failed = /** @type {(inputs: Import_Stat_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Failed: {count}" |
*
* @param {Import_Stat_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_failed = /** @type {((inputs: Import_Stat_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_failed(inputs)
	return cs_import_stat_failed(inputs)
});